module.exports = __webpack_public_path__ + "bdf870c53a0044854e7c710cabd57d24.pdf";